/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import view setting Fee
import MccMdr from '../views/setting-fee/MccMdr.vue';
import SettingSpeFee from '../views/setting-fee/SettingSpeFee.vue';
import ChangeLogFeeSpe from '../views/setting-fee/ChangeLogFeeSpe.vue';

import { setBreadcrumb } from './index';

const settingFeeRoute = {
  path: '/setting-fee',
  name: 'SettingFee',
  children: [
    {
      path: '/setting-fee/mccmdr',
      meta: {
        title: 'BNI QRIS - MCC MDR',
        appBarTitle: 'MCC MDR',
        breadcrumbs: () => [
          setBreadcrumb('setting fee', '/setting-fee', true),
          setBreadcrumb('MCC MDR', '/setting-fee/mccmdr'),
        ],
      },
      component: MccMdr,
    },
    {
      path: '/setting-fee/setting-spe-fee',
      meta: {
        title: 'BNI QRIS - Setting SPE Fee',
        appBarTitle: 'Setting SPE Fee',
        breadcrumbs: () => [
          setBreadcrumb('setting fee', '/setting-fee', true),
          setBreadcrumb('Setting SPE Fee', '/setting-fee/setting-spe-fee'),
        ],
      },
      component: SettingSpeFee,
    },
    {
      path: '/setting-fee/change-log-spe-fee',
      meta: {
        title: 'BNI QRIS - Change Log Fee SPE',
        appBarTitle: 'Change Log Fee SPE',
        breadcrumbs: () => [
          setBreadcrumb('setting fee', '/setting-fee', true),
          setBreadcrumb(
            'Change Log Fee SPE',
            '/setting-fee/change-log-spe-fee'
          ),
        ],
      },
      component: ChangeLogFeeSpe,
    },
  ],
  meta: {
    title: 'BNI QRIS - Setting Fee',
    appBarTitle: 'Setting Fee',
  },
  component: Parent,
};
export default settingFeeRoute;
